import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-waist-circumference',
  templateUrl: './waist-circumference.component.svg',
  styleUrls: [],
})
export class WaistCircumferenceComponent extends MedrecordIcon {
  viewHeight: number = 24;
  viewWidth: number = 24;
}
